import React, { useEffect, useRef } from "react";
import { scrollToRef } from "../../../helpers/scroll_to_ref";
import FreeCarousel from "../FreeCarousel/FreeCarousel";
import FreeChallenge from "../FreeChallenge/FreeChallenge";
import FreeFaq from "../FreeFaq/FreeFaq";
import FreeHeader from "../FreeHeader/FreeHeader";
import FreePackage from "../FreePackage/FreePackage";
import FreeStartHere from "../FreeStartHere/FreeStartHere";
import FreeSteps from "../FreeSteps/FreeSteps";
import FreeStrength from "../FreeStrength/FreeStrength";
import FreeTextBanner from "../FreeTextBanner/FreeTextBanner";
import { Wrapper } from "./styles";

function FreeLandingPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  const packageRef = useRef(null);

  return (
    <>
      <Wrapper>
        <FreeHeader />
        <FreeSteps />
        <FreePackage onScrollToPackage={() => scrollToRef(packageRef, 80)} />

        <FreeChallenge />
        <FreeStartHere />

        <FreeStrength />
        <FreeCarousel />

        <FreeTextBanner />

        <div ref={packageRef}>
          <FreeFaq />
        </div>
      </Wrapper>
    </>
  );
}

export default FreeLandingPage;
